import { KdsLink, KdsText } from "@kazaar-platform/design-system";
import { useTranslate } from "@tolgee/react";

import { type OrderItemPageActivityLogOrderNumberProps } from "./OrderItemPageActivityLogOrderNumber.types";

export const OrderItemPageActivityOrderNumber = ({
  file,
  orderNumberId,
}: OrderItemPageActivityLogOrderNumberProps) => {
  const { t } = useTranslate();

  return (
    <div className="flex items-center gap-sp-xs2">
      <KdsText>
        {t("order.myOrdersItemDetails.activityFeed.action.orderNumber.intro", {
          orderNumber: orderNumberId,
        })}
      </KdsText>

      {file && (
        <KdsLink href={file?.url} target="_blank" size="sm">
          {file?.name}
        </KdsLink>
      )}

      <div className="flex items-center gap-sp-xs2">
        <KdsText>
          {t(
            "order.myOrdersItemDetails.activityFeed.action.orderNumber.suffix"
          )}
        </KdsText>
      </div>
    </div>
  );
};
